const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const applyForActions = require('actions/applyForActions');

class MyApplyForView extends React.Component {
    buildWizard() {
        const immFinalButton = this.props.immApplyForState.get('finalButton');
        const immSteps = this.props.immApplyForState.get('steps');
        const stepsAmount = immSteps.size;
        const wizardClass = 'my-applyfor__wizard';
        const actions = {
            setVisibleStep: this.props.setVisibleStep
        }

        let visibleStep = this.props.immApplyForState.get('visibleStep');

        return (
            <Wizard
                wizardClass={wizardClass}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
            >
                <WizardStep position="onlyOne" immFinalButton={immFinalButton}>
                    <div>nothing here</div>
                </WizardStep>
            </Wizard>
        )
    }

    render() {
        return (
            <div className="my-applyfor">
                {this.buildWizard()}
            </div>
        )
    }
}

MyApplyForView.propTypes = {
    setVisibleStep: PropTypes.func,
    immApplyForState: PropTypes.object
}

module.exports.constructor = MyApplyForView;
module.exports.MyApplyForView = connect(
  state => ({
      immApplyForState: state.applyFor
  }),{
      setVisibleStep: applyForActions.setVisibleStep
  }
)(MyApplyForView);